import { useState, useEffect, useContext, useRef } from 'react';
import './index.scss';
import './mobile.scss';
// import '../../../App.css';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Past30Days from './AccountRecords';
import CurrentSession from './CurrentSession';
import TransactionRecords from './TransactionRecords';
import DateAccBalHeader from './DateAccBalHeader';
import { Export, Print } from './ARExportandPrint';
import { getOffsetTimeQuery } from './Data/DataQuery';
import { useLazyQuery } from '@apollo/client';
import { errRedirectPage } from '../../Common/utils';
import { getProfileByToken } from '../LoginHooks';
import { ApiErrPopupUI } from '../LoginBase';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { setSsoLogout } from '../SsoHook';
import useBroadcastChannel from '../../Common/hooks/useBroadcastChannel';
import Loading from '../../Common/ui-components/Loading';
import CloseButton from '../../Common/ui-components/CloseButton';
import { isEoD } from '../../Common/GlobalFunc';
import { useWindowSize } from '../../Common/CommonHooks.js';
import { getBalanceValue, MyBetSlipContext } from '../BetSlipHooks';


const AccountRecords = ({ sessionServerTimeRef }) => {
    const { t, i18n } = useTranslation();
    const {isMobileSize} = useWindowSize()
    const [tab, setTab] = useState(2);
    const [updateBalanceClick, setUpdateBalanceClick] = useState(1);
    const [hasScroll, setHasScroll] = useState(false);
    const [disableScroll, setDisableScroll] = useState(false);
    const [showExportPrint, setShowExportPrint] = useState(false);
    const [downloadData, setDownloadData] = useState({
        searchParams: {},
        statementData: []
    });
    const urlParams = useParams();    
    const { balance, setBalance } = useContext(MyBetSlipContext);
    
    const [balanceLoaded, setBalanceLoaded] = useState(false);
    const [offsetDate, setOffsetDate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isCallingApi, setIsCallingApi] = useState(false);
    const [isAddDelay, setIsAddDelay] = useState(true);
    const ssoLogoutBoardcast = useBroadcastChannel('ssoLogoutNow');
    const isSpeedbet = sessionStorage.getItem('speedbet_cust') === 'Y';
    const [isApiErr, setIsApiErr] = useState(false);
    const [errorMessageCode, setErrorMessageCode] = useState(''); // IB
    let serverTime = sessionServerTimeRef?.current || (new Date()).getTime(); 
    if (sessionStorage.getItem('serverTimeDiff')) {
        serverTime = (new Date().getTime()) - sessionStorage.getItem('serverTimeDiff');
    }
    const [loadSimpleMatchListQuery, simpleGqlVars] = useLazyQuery(getOffsetTimeQuery(), {
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
        onCompleted: (data) => {
            const offset = data?.timeOffset?.fb || 0;
            const searchEndDt = new Date(serverTime + offset * 1000);
            setOffsetDate(searchEndDt);
            setIsLoading(false);
        },
        onError: (err) => {
            const searchEndDt = serverTime;
            setOffsetDate(searchEndDt);
            setIsLoading(false);
            errRedirectPage(err);
        }
    });

    useEffect(()=>{
        if(!isMobileSize){
            document.documentElement.style.overflow = 'hidden'
        }else{
            document.documentElement.removeAttribute('style')
        }
    },[isMobileSize])

    const getEodMessage = () => {
        let message =
            i18n.language === 'en' ? sessionStorage.getItem('OOSEngContent') : sessionStorage.getItem('OOSChiContent');
        if (message == null || message.length <= 0) {
            message = t('LB_BS_EOD');
        }
        return message;
    };

    useEffect(() => {
        const init = async() =>{
            if(await checkIsEod()){
                window.alert(getEodMessage())
                window.close()
            }
        }
        init()
        if (urlParams?.curTab === 'transactionRecords') {
            setTab(1);
        }
    }, []);

    useEffect(() => {
        setDisableScroll(false);
        loadSimpleMatchListQuery();
    }, [tab]);

    const checkIsEod = async () => {
        return setEodUi();
    };

    const setEodUi = () => {
        if (isEoD()) {
            return true;
        } else {
            return false;
        }
    };

    const refreshBalance = async () => {
        !balanceLoaded && setBalance('...');
        let balance
        balance = parseFloat(sessionStorage.getItem('balance')); //await getBalanceValue();
        const resData = await getBalanceValue(true);
        if (resData?.balanceStatus == 0 && resData?.balance !== '') {
            balance = resData?.balance
        }
        if (!isNaN(balance)) {
            setBalance(balance.toLocaleString(undefined, { minimumFractionDigits: 2 }));
            //updateBetSlipBalance(balance.toLocaleString(undefined, { minimumFractionDigits: 2 }));
        } else {
            setBalance('---');
        }
        setBalanceLoaded(true);
    };

    const isReturnErrorCode = (errorCode, action) => {
        const code = parseInt(errorCode);
        if (!isNaN(code)) {
            if (code == -2) {
                setSsoLogout();
                ssoLogoutBoardcast?.postMessage('ssoLogoutNow');
                window.alert(t(window.globalConfig.RETAIN_BETS_IN_BET_SLIP_ON_LOGOUT ? 'NEW_LB_BS_SSO_SIGN_OUT_PASSIVE' : 'LB_BS_SSO_SIGN_OUT_PASSIVE'));
                window.close();
                return true;
            }

            if (code == 1) {
                if (action == 'recall') {
                    window.alert(sessionStorage.getItem('recall_error'));
                }
                if (action == 'stmt') {
                    window.alert(sessionStorage.getItem('stmt_error'));
                }
                window.close();
                return true;
            }
            if(code == 9){
                window.alert(t('LB_BS_EOD'));
                window.close();
                return true
            }
            if (code >= 100 && code <= 120) {
                window.alert(t('IB_ERROR_' + errorCode));
                window.close();
                return true;
            }
        }
        return false;
    };
    const printRef = useRef()

    if (isLoading) {
        return <Loading />;
    }

    

    return (
        <Scrollbars
            className={`ARInbox-scrollbars ${disableScroll ? 'disableScroll' : ''}`}
            style={{ height: '100dvh' }}
            autoHeight={false}
            autoHide={disableScroll}
            key={tab}
            onUpdate={(data) => setHasScroll(data.top > 0)}
        >
            <div ref={printRef}  className={`ARInbox ARInbox-tab-${tab} ${hasScroll > 0 ? 'hasScroll' : ''}`}>
                <div className="commom-header">
                    <div className={`ARInboxTitle ${isMobileSize?'popupTitle':''}`}>
                        <div>{t('LB_BETSLIP_ACCOUNTRECORDS')}</div>
                        <div className="df controlContainer">
                            {showExportPrint ? (
                                <>
                                    {tab === 2 && <Export downloadData={downloadData} offsetDate={offsetDate} />}
                                    <Print printRef={printRef} currentTab={tab} />
                                </>
                            ) : null}
                        </div>
                        {isMobileSize && <CloseButton isIOSPWA={true} />}
                    </div>
                    <div className="ARInboxHeader">
                        {new Array(3).fill('1').map((item, index) => {
                            return (
                                <div className={`ARInboxHeaderCell ${tab === index && 'active'} `} key={index}>
                                    <div
                                        className={`ARInboxHeaderCellInner ${0 === index && 'firstCell'}`}
                                        onClick={() => {
                                            !isCallingApi && tab !== index && setTab(index);
                                        }}
                                    >
                                        {t(`LB_BETSLIP_ACCOUNTRECORDSTAB${index}`)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <DateAccBalHeader updateBalanceClick={updateBalanceClick} tab={tab} balanceLoaded={balanceLoaded} setBalanceLoaded={setBalanceLoaded} offsetDate={offsetDate} balance={balance} />
                </div>

                <div className={`${tab === 0 ? 'ARMain' : 'hide'} `}>
                    <CurrentSession
                        setTab={setTab}
                        setShowExportPrint={setShowExportPrint}
                        currentTab={tab}
                        isShow={tab === 0}
                        refreshBalance={refreshBalance}
                    />
                </div>
                {tab === 1 && (
                    <div className={`${tab === 1 ? 'ARMain' : 'hide'} `}>
                        <TransactionRecords
                            setShowExportPrint={setShowExportPrint}
                            currentTab={tab}
                            isShow={balanceLoaded}
                            setIsApiErr={setIsApiErr}
                            isReturnErrorCode={isReturnErrorCode}
                            setIsCallingApi={setIsCallingApi}
                            refreshBalance={refreshBalance}
                        />
                    </div>
                )}
                {tab === 2 && (
                    <div id="acPastDays" className={`${tab === 2 ? 'ARMain' : 'hide'} `}>
                        <Past30Days
                            setShowExportPrint={setShowExportPrint}
                            offsetDate={offsetDate}
                            currentTab={tab}
                            updateDownloadData={setDownloadData}
                            balanceLoaded={balanceLoaded}
                            isSpeedbet={isSpeedbet}
                            setIsApiErr={setIsApiErr}
                            isReturnErrorCode={isReturnErrorCode}
                            setErrorMessageCode={setErrorMessageCode}
                            setDisableScroll={setDisableScroll}
                            setIsCallingApi={setIsCallingApi}
                            isAddDelay={isAddDelay}
                            setIsAddDelay={setIsAddDelay}
                            setUpdateBalanceClick={setUpdateBalanceClick}
                            refreshBalance={refreshBalance}
                            loadSimpleMatchListQuery={loadSimpleMatchListQuery}
                            sessionServerTimeRef={sessionServerTimeRef}
                        />
                    </div>
                )}

                <ApiErrPopupUI isApiErr={isApiErr} errorMessageCode={errorMessageCode} />
            </div>
        </Scrollbars>
    );
};

export default AccountRecords;
